const PlummeAnnualReporting = (() => {
  const parseComparatives = (source: string) => {
    const seen = new Set<string>();
    const rows = source.split(/\r?\n/).filter((line) => line.trim()).map((line) => {
      const parts = line.split(';');
      const code = (parts[0] || '').trim();
      const value = (parts[2] || '').trim().replace(',', '.');
      if (parts.length !== 3 || !/^[1-8]\d{3}$/.test(code) || seen.has(code) || !value || !Number.isFinite(Number(value))) {
        throw new Error('clo.comparativeInvalidRow');
      }
      seen.add(code);
      return { code, label: parts[1].trim(), amount: Math.round(Number(value) * 100) / 100 };
    });
    if (!rows.length || rows.length > 1000 || Math.abs(rows.reduce((sum, row) => sum + row.amount, 0)) > 0.01) throw new Error('clo.comparativeNotBalanced');
    return rows;
  };
  const documentStatus = (document: any) => !document || document.stale ? 'klar' : document.summary?.allSigned ? 'signert' : 'sendt';
  return { parseComparatives, documentStatus };
})();
Object.assign(window, { PlummeAnnualReporting });
